module.exports = __webpack_public_path__ + "img/top-bg-topic.227ff42d.jpg";